import React from 'react';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        // Clear any authentication tokens or user data here
        localStorage.removeItem('accessToken'); // Example for removing token from localStorage

        // Redirect to the root URL
        navigate('/');
    };

    return (
        <>
            {/* Mobile overlay */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={onClose}
                />
            )}
            
            {/* Sidebar */}
            <div className={`
                fixed lg:static inset-y-0 left-0 z-50 w-64 bg-gray-900 transform transition-transform duration-300 ease-in-out
                ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
            `}>
                <div className="p-4 space-y-16">
                    {/* Close button for mobile */}
                    <div className="flex justify-between items-center lg:hidden">
                        <div className="text-lg font-bold text-white">Menu</div>
                        <button onClick={onClose} className="text-white text-2xl">
                            ×
                        </button>
                    </div>
                    
                    <div className="text-lg font-bold"></div>
                    <ul className="space-y-6">
                        <li><a href="/dashboard" className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white">Home</a></li>
                        <li><a href="/bookings" className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white">Bookings</a></li>
                        <li><a href="/customers" className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white">Customers</a></li>
                        <li><a href="/reviews" className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white bg-gray-700">Reviews</a></li>
                        <li><a href="/slots" className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white">Slots</a></li>
                        <li><a href="/promos" className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white">Promo Code</a></li>
                        <li>
                            <button className="block px-4 py-2 my-4 rounded text-xl hover:bg-gray-700 text-white w-full text-left" onClick={handleLogout}>
                                Logout
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Sidebar;